import { IDB_userProfiles } from '../IDB/IDB.dexie'
import { IDB_locationOwnershipRead } from '../IDB/IDB.table.locationOwnership'

export async function Loca_ownersGet(locationId: number) {
    const ownership = await IDB_locationOwnershipRead(locationId)
    if (ownership == null || ownership.owners == null || ownership.owners.length === 0) return []

    return Promise.all(
        ownership.owners.map(async (owner) => ({
            ...owner,
            profile: await IDB_userProfiles().get(owner.userId),
        }))
    )
}
